"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = Container;
exports.View = View;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _Button = require("./Button");
var _Tabs = _interopRequireDefault(require("./styles/Tabs"));
var _excluded = ["className", "isActive", "children"],
  _excluded2 = ["className", "panelsClassName", "children", "onChange"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function View(_ref) {
  var className = _ref.className,
    isActive = _ref.isActive,
    children = _ref.children,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var isFunctionChildren = typeof children === 'function';
  if (props.disabled) {
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('tab-view', {
      'tab-view--active': isActive
    }, _Tabs["default"].view, isActive && _Tabs["default"].view_active, className),
    role: "tabpanel",
    "aria-hidden": !isActive
  }, isFunctionChildren ? children(isActive) : children);
}
View.displayName = 'TabView';
function Container(_ref2) {
  var className = _ref2.className,
    panelsClassName = _ref2.panelsClassName,
    children = _ref2.children,
    onChange = _ref2.onChange,
    props = (0, _objectWithoutProperties2["default"])(_ref2, _excluded2);
  var _useState = (0, _react.useState)(true),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isFirst = _useState2[0],
    setIsFirstRender = _useState2[1];
  var _useState3 = (0, _react.useState)(props.defaultTab),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    currentTab = _useState4[0],
    setCurrentTab = _useState4[1];
  var tabs = children.filter(function (x) {
    return !!x && !x.props.disabled;
  });
  var firstChild = tabs[0].props;
  var activeTab = props.activeTab || currentTab;
  function onTabChange(name) {
    if (props.activeTab) {
      onChange && onChange(name);
    } else {
      setCurrentTab(name);
    }
  }
  (0, _react.useEffect)(function () {
    if (!isFirst && currentTab) {
      onChange && onChange(currentTab);
    } else if (isFirst && currentTab) {
      setIsFirstRender(false);
    }
    if (!activeTab) {
      var newTab = firstChild || {
        name: 'NONE'
      };
      setCurrentTab(newTab.name);
    }
  }, [currentTab, activeTab, isFirst, firstChild, onChange]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('tabs', _Tabs["default"].container, className)
  }, /*#__PURE__*/_react["default"].createElement("ul", {
    className: (0, _classnames["default"])('tabs__controls', _Tabs["default"].controls),
    role: "tablist"
  }, tabs.map(function (t) {
    var _t$props = t.props,
      name = _t$props.name,
      displayName = _t$props.displayName;
    var isActive = name === activeTab;
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: name,
      className: (0, _classnames["default"])('tab-control', {
        'tab-control--active': isActive
      }, _Tabs["default"].tabControl, isActive && _Tabs["default"].tabControl_active),
      role: "tab"
    }, /*#__PURE__*/_react["default"].createElement(_Button.Button, {
      className: "tab-control__button",
      onClick: function onClick() {
        return onTabChange(name);
      }
    }, displayName || name));
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('tabs__panels', _Tabs["default"].panels, panelsClassName)
  }, tabs.map(function (t) {
    var name = t.props.name;
    var isActive = name === activeTab;
    var props = _objectSpread(_objectSpread({}, t.props), {}, {
      isActive: isActive
    });
    return /*#__PURE__*/_react["default"].createElement(View, (0, _extends2["default"])({
      key: name
    }, props));
  })));
}
function ValidateChildPropType(propValue, _, componentName, __, propFullName) {
  propValue.forEach(function (item) {
    if (!item.type || !item.type.name || item.type.name !== 'TabView') {
      return new Error("TabContainer propTypes: Invalid prop '".concat(propFullName, "' supplied to ").concat(componentName, ". Validation failed."));
    }
  });
}
Container.displayName = 'TabContainer';
Container.defaultProps = {
  activeTab: null,
  defaultTab: null
};
var Tabs = {
  Container: Container,
  View: View
};
var _default = exports["default"] = Tabs;